// extracted by mini-css-extract-plugin
export default {"banner":"LJmZ5"};